import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import customStyle from "./home.module.css";
import { List, ListItem, styled } from "@mui/material";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


const Image = styled("img")({
  marginBottom: "8px",
});

function Home() {
  return (
    <>
      {/* banner */}
      <Box component={"section"} className={customStyle.mortgageBanner} mb={2}>
        <Container sx={{ height: "100%" }}>
          <Grid container alignItems={"center"} height={"100%"}>
            <Grid size={{ sm: 6, }} mb={4}>
              <Typography variant="h1" fontSize={30} mb={1} color="primary">
                <strong>A mortgage loan for multiple purposes!</strong>
              </Typography>
              <Typography variant="body1" mb={2}>
                Get up to 100% of the value of your property as a loan to fund
                planned needs – investment in business, home renovation,
                purchase of property, wedding in the family, children’s
                education and so on. Mortgage loan against property are
                offered at attractive interest rates.
              </Typography>
              <Button
                color="primary"
                size="large"
                variant="contained"
                type="button"
              >
                Get instant funds
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* banner */}

      <Box component={"main"}>
        {/* container */}
        <Container>
          {/* section mission and values */}
          <Grid container my={6}>
            <Grid size={12}>
              <Typography
                variant="h4"
                mb={3}
                sx={{
                  textAlign: { xs: 'center', sm: 'left' }
                }}
              >
                Mission and values
              </Typography>
            </Grid>
            {images.map((item, index) => (
              <Grid key={index} size={{ lg: 2.4, sm: 4 }} textAlign="center" width={"100%"}>
                <Image src={item.path} alt={item.title} width={"120px"} />
                <Typography variant="body1" color="primary">
                  {item.title}
                </Typography>
              </Grid>
            ))}
          </Grid>
          {/* /section mission and values */}
        </Container>
        {/* /container */}
        {/* section our businesses */}
        <Box component={"section"} className={customStyle.mortgageBusinessesBanner} sx={{ py: { sm: 6, xs: 4 } }}>
          <Container sx={{ height: "100%" }}>
            <Grid container alignItems={"center"} height={"100%"} spacing={2}>
              <Grid size={12}>
                <Typography
                  variant="h4"
                  mb={3}
                  sx={{
                    textAlign: { xs: 'center', sm: 'left' }
                  }}
                >
                  Our businesses
                </Typography>
              </Grid>
              {businesses.map((item, index) => index < 3 && (
                <Grid key={index} size={{ md: 4, sm: 6 }} mb={3} textAlign="center" width={"100%"} bgcolor={"white"} sx={{ borderRadius: 2 }} p={1} height={"350px"}>
                  <Image src={item.path} alt={item.title} sx={{ borderRadius: 2 }} width={"100%"} />
                  <Typography variant="body1" color="primary">
                    {item.title}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
        {/* /section our businesses */}

        {/* section loan against property */}
        <Box component={"section"} my={6}>
          <Container sx={{ height: "100%" }}>
            <Grid container alignItems={"center"} height={"100%"} spacing={2}>
              <Grid size={12}>
                <Typography
                  variant="h4"
                  mb={10}
                  sx={{ textAlign: 'center' }}
                >
                  Loan Against Property: Benefits & Features
                </Typography>
              </Grid>
              <Grid size={{ md: 6, xs: 12 }} mb={3} width={"100%"} sx={{ borderRadius: 2 }}>
                <Typography variant="h3" color="primary" fontWeight={"bold"}>
                  Mortgage Loans simplified.
                </Typography>
                <List aria-labelledby="decorated-list-demo">
                  <ListItem sx={{ px: 0 }}>
                    <CurrencyExchangeIcon color="primary" sx={{ mr: 1, minWidth: "auto" }} fontSize="small" />
                    <Typography variant="body1" color="initial" fontWeight={550}>Flexible Loan Tenure of up to 40 years</Typography>
                  </ListItem>
                  <ListItem sx={{ px: 0 }}>
                    <AccessTimeIcon color="primary" sx={{ mr: 1, minWidth: "auto" }} fontSize="small" />
                    <Typography variant="body1" color="initial" fontWeight={550}>Instant Provisional Sanction*</Typography>
                  </ListItem>
                  <ListItem sx={{ px: 0 }}>
                    <PersonalVideoIcon color="primary" sx={{ mr: 1, minWidth: "auto" }} fontSize="small" />
                    <Typography variant="body1" color="initial" fontWeight={550}>Attractive Interest Rates</Typography>
                  </ListItem>
                  <ListItem sx={{ px: 0 }}>
                    <ContentCopyIcon color="primary" sx={{ mr: 1, minWidth: "auto" }} fontSize="small" />
                    <Typography variant="body1" color="initial" fontWeight={550}>Special Offers for Govt Employees</Typography>
                  </ListItem>
                </List>
              </Grid>
              <Grid size={{ md: 6, xs: 12 }} mb={3} width={"100%"} textAlign={"right"} sx={{ borderRadius: 2 }}>
                <Image src="/assets/images/undraw_finance_m6vw.svg" alt="" sx={{ borderRadius: 2 }} width={"100%"} />
              </Grid>
            </Grid>
          </Container>
        </Box>
        {/* /section loan against property */}
      </Box>
    </>
  );
}

const images = [
  { title: "Excellence", path: "/assets/images/icons/excellence.svg" },
  { title: "Customer Focus", path: "/assets/images/icons/Customer-focus.svg" },
  { title: "Product Leadership", path: "/assets/images/icons/product-leadership.svg" },
  { title: "People", path: "/assets/images/icons/people.svg" },
  { title: "Sustainability", path: "/assets/images/icons/Sustainability.svg" },
]

const businesses = [
  { title: "Mortgage Retail business is targeted at individuals, salaried professionals, micro and small businesses, such as grocery stores, Self Help Groups (SHGs).", path: "/assets/images/Retail-Banking-new.jpg" },
  { title: "Post the merger with Mortgage, Mortgage house has secured a strong home finance brand. Mortgage house was a pioneer in the Housing Loan Finance market in India and over the years built a strong brand equity.", path: "/assets/images/Home-loan-mortages.png" },
  { title: "The target segment for this business is large corporates, PSUs, Government, and multinational corporations. For these customers, the Bank provides a wide range of commercial and transactional", path: "/assets/images/Wholesale-Banking-new.jpg" },
]

export default Home;
